import { MusePeer } from '@/services/RoomContextMusePeer'
import { useMemo } from 'react'
import { Video2, VideoSource } from '../../shared/Video2'
import { VideoOptionsOverlay } from '../../shared/VideoOptionsOverlay'
import { UsernameOverlay } from '../../shared/UsernameOverlay'
import { cn } from '@/utlis/cn'

type SidebarScreenProps = {
    user: MusePeer
    videoClassName?: string
}
export function SidebarScreen(props: SidebarScreenProps) {
    const vid = useMemo(() => {
        return new VideoSource(props.user, 'screen', props.user.remoteDesktop ?? undefined)
    }, [props.user])

    return (
        <div className="relative group w-full">
            <UsernameOverlay size="small" peer={props.user} kind="screen" />
            <VideoOptionsOverlay size="small" peer={props.user} kind="screen" />
            <Video2
                key={vid.id}
                videoSource={vid}
                ignoreAspectRatio
                className={cn('w-full aspect-16/9 object-cover', props.videoClassName)}
            />
        </div>
    )
}
